import * as THREE from 'three';
import { get as lodashGet } from 'lodash';
export const Constants = {
    WORLD_SIZE: 1024000,
    PROJECTION_WORLD_SIZE: 1024000 / (6378137.0 * Math.PI * 2),
    MERCATOR_A: 6378137.0,
    DEG2RAD: Math.PI / 180,
    RAD2DEG: 180 / Math.PI,
    EARTH_CIRCUMFERENCE: 40075000
};
export const projectedUnitsPerMeter = (latitude) => {
    return Math.abs(Constants.WORLD_SIZE / Math.cos(Constants.DEG2RAD * latitude) / Constants.EARTH_CIRCUMFERENCE);
};
export const projectToWorld = (coords) => {
    const projected = [
        -Constants.MERCATOR_A * Constants.DEG2RAD * coords[0] * Constants.PROJECTION_WORLD_SIZE,
        -Constants.MERCATOR_A *
            Math.log(Math.tan(Math.PI * 0.25 + 0.5 * Constants.DEG2RAD * coords[1])) *
            Constants.PROJECTION_WORLD_SIZE
    ];
    if (!coords[2])
        projected.push(0);
    else {
        const pixelsPerMeter = projectedUnitsPerMeter(coords[1]);
        projected.push(coords[2] * pixelsPerMeter);
    }
    return new THREE.Vector3(projected[0], projected[1], projected[2]);
};
export const calculateProjectionMatrix = (matrix, modelTransform) => {
    const rotationX = new THREE.Matrix4().makeRotationAxis(new THREE.Vector3(1, 0, 0), modelTransform.rotateX);
    const rotationY = new THREE.Matrix4().makeRotationAxis(new THREE.Vector3(0, 1, 0), modelTransform.rotateY);
    const rotationZ = new THREE.Matrix4().makeRotationAxis(new THREE.Vector3(0, 0, 1), modelTransform.rotateZ);
    const m = new THREE.Matrix4().fromArray(matrix);
    const l = new THREE.Matrix4()
        .makeTranslation(modelTransform.translateX, modelTransform.translateY, modelTransform.translateZ)
        .scale(new THREE.Vector3(modelTransform.scale, -modelTransform.scale, modelTransform.scale))
        .multiply(rotationX)
        .multiply(rotationY)
        .multiply(rotationZ);
    return m.multiply(l);
};
export const _get = (searchObject, path, defaultVal) => {
    const result = lodashGet(searchObject, path);
    if (result === null || result === undefined) {
        return defaultVal;
    }
    if (typeof result === 'string' && result.trim() === '') {
        return defaultVal;
    }
    return result;
};
export const uuid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
//# sourceMappingURL=utils.js.map